import {
  DAY_DATE_FORMAT_7,
  DAY_DATE_FORMAT_8,
} from '@components/utils/constants' 
import { formatDate } from '@components/utils/dateFormatter'
import samplePic1 from 'public/samplePic1.png'
import samplePic2 from 'public/samplePic2.png'
import samplePic3 from 'public/samplePic3.jpg'
import samplePic4 from 'public/samplePic4.jpg'
import samplePic5 from 'public/samplePic5.jpg'
import samplePic6 from 'public/samplePic6.png'
import samplePic7 from 'public/samplePic7.png'
import { handleReturnExchangeItemClickGAEvent } from './eventsHelper'

interface IGetReturnExchangeButton {
  productItem: any
  details: any
  returnExchangeClickHandler: (
    product: any,
    val1: string,
    val2?: string | null
  ) => void
  previousPath: string
}

export enum RETURN_EXCHANGE_TYPES {
  RETURN = 'RETURN',
  EXCHANGE = 'EXCHANGE',
}

interface IFullData {
  id?: string
  stockCode?: string
  name?: string
  productId?: string
}

export interface ISelectedProduct {
  name: string
  allowedToReturn: boolean
  allowedToExchange: boolean
  fullData: IFullData
}

const getReturnOrExchangeEligibility = (product: any, details: any) => {
  let updatedProduct = { ...product }
  let returnEligible = false
  let replacementEligible = false
  const isFreeGiftExist = details?.order?.items?.some(
    (item: any) => item?.price?.raw?.withTax === 0
  )

  let isProductReplacement =
    updatedProduct?.customInfo4Formatted &&
    updatedProduct?.customInfo4Formatted !== ''
      ? true
      : false
  let isProductReturn =
    updatedProduct?.customInfo5Formatted &&
    updatedProduct?.customInfo5Formatted !== ''
      ? true
      : false

  if (!isProductReplacement && isProductReturn) {
    // because if a product returnable, then that product will also be exchangeable
    isProductReplacement = true
    updatedProduct = {
      ...product,
      customInfo4Formatted: product?.customInfo5Formatted,
    }
  }

  const currentDate: any = new Date(formatDate(new Date(), DAY_DATE_FORMAT_7))
  const returnDate = updatedProduct?.deliveredDate
    ? new Date(updatedProduct?.deliveredDate)
    : null
  returnDate &&
    returnDate?.setDate(
      returnDate.getDate() +
        (isProductReturn
          ? parseInt(updatedProduct?.customInfo5Formatted, 10)
          : 0)
    )
  const returnDateWindow: any = returnDate
    ? new Date(formatDate(new Date(returnDate), DAY_DATE_FORMAT_7))
    : null

  const replacementDate = updatedProduct?.deliveredDate
    ? new Date(updatedProduct?.deliveredDate)
    : null
  replacementDate &&
    replacementDate?.setDate(
      replacementDate.getDate() +
        (isProductReplacement
          ? parseInt(updatedProduct?.customInfo4Formatted, 10) === 301
            ? 30
            : parseInt(updatedProduct?.customInfo4Formatted, 10)
          : 0)
    )
  const replacementDateWindow: any = replacementDate
    ? new Date(formatDate(new Date(replacementDate), DAY_DATE_FORMAT_7))
    : null

  const returnDiffDays =
    (returnDateWindow - currentDate) / (1000 * 60 * 60 * 24)
  const replacementDiffDays =
    (replacementDateWindow - currentDate) / (1000 * 60 * 60 * 24)
  if (returnDiffDays > 0 && updatedProduct?.allowedToReturn) {
    returnEligible = true
  }
  if (replacementDiffDays > 0 && updatedProduct?.allowedToExchange) {
    replacementEligible = true
  }

  if (isProductReplacement && isProductReturn && replacementDiffDays > 0) {
    // because if a product returnable, then that product also be exchangeable
    replacementEligible = true
  }

  return {
    returnEligible: returnEligible,
    replacementEligible: replacementEligible,
    returnDateWindow: returnDateWindow,
    replacementDateWindow: replacementDateWindow,
    isProductReturn: isProductReturn,
    isProductReplacement: isProductReplacement,
    isFreeGiftExist: isFreeGiftExist,
  }
}

export const getReturnExchangeMessage = (product: any, details: any) => {
  const returnOrExchangeData = getReturnOrExchangeEligibility(product, details)
  const {
    isFreeGiftExist,
    isProductReplacement,
    isProductReturn,
    replacementDateWindow,
    replacementEligible,
    returnDateWindow,
    returnEligible,
  } = returnOrExchangeData

  const orderDeliveryStatus = details?.order?.orderStatus?.toLowerCase()

  if (
    product?.deliveredDate &&
    product?.deliveredDate === '0001-01-01T00:00:00' &&
    orderDeliveryStatus !== 'cancelled' &&
    orderDeliveryStatus !== 'cancelledbycustomer' &&
    orderDeliveryStatus !== 'cancelledbystore'
  ) {
    if (isProductReturn && isProductReplacement) {
      const exchangeDays =
        (!product?.customInfo4Formatted ||
          product?.customInfo4Formatted === '') &&
        isProductReturn
          ? product?.customInfo5Formatted
          : product?.customInfo4Formatted
      return (
        <span className="text-blue font-normal text-sm">
          You can exchange within {parseInt(exchangeDays, 10)} days{' '}
          {!isFreeGiftExist
            ? `& return within${' '}
              ${parseInt(product?.customInfo5Formatted, 10)} days`
            : ''}{' '}
          after delivery
        </span>
      )
    } else if (isProductReplacement && !isProductReturn) {
      return (
        <span className="text-blue font-normal text-sm">
          You can exchange within {parseInt(product?.customInfo4Formatted, 10)}{' '}
          days after delivery
        </span>
      )
    } else if (!isProductReplacement && isProductReturn && !isFreeGiftExist) {
      return (
        <span className="text-blue font-normal text-sm">
          You can return within {parseInt(product?.customInfo5Formatted, 10)}{' '}
          days after delivery
        </span>
      )
    } else {
      return null
    }
  } else if (
    product?.deliveredDate &&
    product?.deliveredDate !== '0001-01-01T00:00:00' &&
    orderDeliveryStatus === 'delivered'
  ) {
    if (returnEligible && replacementEligible) {
      return (
        <>
          {isProductReplacement ? (
            <span className="text-blue font-normal text-sm">
              Exchange window open till{' '}
              {formatDate(replacementDateWindow, DAY_DATE_FORMAT_8)}
            </span>
          ) : null}
          {isProductReturn && !isFreeGiftExist ? (
            <span className="text-blue font-normal text-sm">
              Return window open till{' '}
              {formatDate(returnDateWindow, DAY_DATE_FORMAT_8)}
            </span>
          ) : null}
        </>
      )
    } else if (replacementEligible && !returnEligible) {
      return (
        <>
          {isProductReplacement ? (
            <span className="text-blue font-normal text-sm">
              Exchange window open till{' '}
              {formatDate(replacementDateWindow, DAY_DATE_FORMAT_8)}
            </span>
          ) : null}
          {isProductReturn && !isFreeGiftExist ? (
            <span className="text-primary font-normal text-sm">
              Return window closed on{' '}
              {formatDate(returnDateWindow, DAY_DATE_FORMAT_8)}
            </span>
          ) : null}
        </>
      )
    } else if (!replacementEligible && returnEligible) {
      return (
        <>
          {isProductReplacement ? (
            <span className="text-primary font-normal text-sm">
              Exchange window closed on{' '}
              {formatDate(replacementDateWindow, DAY_DATE_FORMAT_8)}
            </span>
          ) : null}
          {isProductReturn && !isFreeGiftExist ? (
            <span className="text-blue font-normal text-sm">
              Return window open till{' '}
              {formatDate(returnDateWindow, DAY_DATE_FORMAT_8)}
            </span>
          ) : null}
        </>
      )
    } else {
      return (
        <>
          {isProductReplacement ? (
            <span className="text-primary font-normal text-sm">
              Exchange window closed on{' '}
              {formatDate(replacementDateWindow, DAY_DATE_FORMAT_8)}
            </span>
          ) : null}
          {isProductReturn && !isFreeGiftExist ? (
            <span className="text-primary font-normal text-sm">
              Return window closed on{' '}
              {formatDate(returnDateWindow, DAY_DATE_FORMAT_8)}
            </span>
          ) : null}
        </>
      )
    }
  } else {
    return null
  }
}

export const getReturnExchangeButton = (props: IGetReturnExchangeButton) => {
  const {
    productItem: product,
    details,
    returnExchangeClickHandler,
    previousPath,
  } = props

  const returnOrExchangeData = getReturnOrExchangeEligibility(product, details)
  const {
    isFreeGiftExist,
    isProductReplacement,
    isProductReturn,
    replacementDateWindow,
    replacementEligible,
    returnDateWindow,
    returnEligible,
  } = returnOrExchangeData

  const orderDeliveryStatus = details?.order?.orderStatus?.toLowerCase()

  if (
    product?.deliveredDate &&
    product?.deliveredDate !== '0001-01-01T00:00:00' &&
    orderDeliveryStatus === 'delivered'
  ) {
    if (returnEligible && replacementEligible) {
      return (
        <>
          {isProductReplacement ? (
            <span
              className="text-orange font-semibold text-base cursor-pointer"
              onClick={() => {
                handleReturnExchangeItemClickGAEvent({
                  item: product,
                  previousPath,
                })
                returnExchangeClickHandler(
                  product,
                  RETURN_EXCHANGE_TYPES.EXCHANGE,
                  isProductReturn && !isFreeGiftExist
                    ? RETURN_EXCHANGE_TYPES.RETURN
                    : null
                )
              }}
            >
              Exchange
              {isProductReturn && !isFreeGiftExist
                ? '/Return this item →'
                : ' this item →'}
            </span>
          ) : null}
        </>
      )
    } else if (replacementEligible && !returnEligible) {
      return (
        <>
          {isProductReplacement ? (
            <span
              className="text-orange font-semibold text-base cursor-pointer"
              onClick={() => {
                handleReturnExchangeItemClickGAEvent({
                  item: product,
                  previousPath,
                })
                returnExchangeClickHandler(
                  product,
                  RETURN_EXCHANGE_TYPES.EXCHANGE
                )
              }}
            >
              Exchange this item →
            </span>
          ) : null}
        </>
      )
    } else if (!replacementEligible && returnEligible) {
      return (
        <>
          {isProductReturn && !isFreeGiftExist ? (
            <span
              className="text-orange font-semibold text-base cursor-pointer"
              onClick={() => {
                handleReturnExchangeItemClickGAEvent({
                  item: product,
                  previousPath,
                })
                returnExchangeClickHandler(
                  product,
                  RETURN_EXCHANGE_TYPES.RETURN
                )
              }}
            >
              Return this item →
            </span>
          ) : null}
        </>
      )
    } else {
      return null
    }
  } else {
    return null
  }
}

export const samplePhotos = [
  {
    id: 1,
    url: samplePic1,
    tickIcon: true,
  },
  {
    id: 2,
    url: samplePic2,
    tickIcon: false,
  },
  {
    id: 3,
    url: samplePic3,
    tickIcon: true,
  },
  {
    id: 4,
    url: samplePic4,
    tickIcon: false,
  },
  {
    id: 5,
    url: samplePic5,
    tickIcon: true,
  },
  {
    id: 6,
    url: samplePic6,
    tickIcon: false,
  },
  {
    id: 7,
    url: samplePic7,
    tickIcon: true,
  },
]
